import React from 'react';
import Link from 'react-router-dom/es/Link';

import { permissions } from 'config/settings/permissions';
import settings from 'config/constants';

const products = settings.PRODUCTS;

const { path } = products.GRMT;

export default [
  {
    id: `/${path}/dashboard`,
    title: 'Dashboard',
    icon: 'bc-icon-dashboard',
    permission: [permissions.GRMTOperationsDashboard],
    data: [
      {
        id: `/${path}/dashboard/operations`,
        title: <Link to={`/${path}/dashboard/operations`}>Operations Dashboard</Link>,
        permission: [permissions.GRMTOperationsDashboard]
      }
    ]
  },
  {
    id: `/${path}/alert-monitor`,
    title: <Link to={`/${path}/alert-monitor`}>Alert Monitor</Link>,
    icon: 'bc-icon-bell-outline',
    permission: permissions.GeneralAlertMonitor
  },
  {
    id: `/${path}/players`,
    title: <Link className="route_link" to={`/${path}/players`}>Players</Link>,
    icon: 'bc-icon-players-rmt-36',
    permission: permissions.GeneralBox
  },
  {
    id: `/${path}/player-groups`,
    title: <Link className="route_link" to={`/${path}/player-groups`}>Players Group</Link>,
    icon: 'bc-icon-players',
    permission: [permissions.GRMTPlayersGroupSport, permissions.GRMTPlayersGroupCasino]
  },
  {
    id: `/${path}/settings`,
    title: 'Settings',
    icon: 'bc-icon-settings',
    permission: permissions.GeneralSettings,
    data: [
      {
        id: `/${path}/settings/category-settings`,
        title: <Link to={`/${path}/settings/category-settings`}>Category Settings</Link>,
        permission: permissions.GRMTCategorySettings
      },
      {
        id: `/${path}/settings/alert-settings`,
        title: <Link to={`/${path}/settings/alert-settings`}>Alert Settings</Link>,
        permission: permissions.GeneralSettings
      },
      {
        id: `/${path}/settings/user-management`,
        title: <Link to={`/${path}/settings/user-management`}>User Management</Link>,
        permission: [permissions.GeneralSettings, permissions.GRMTAdmin],
        moreThenOne: true
      },
       {
        id: `/${path}/settings/role-management`,
        title: <Link to={`/${path}/settings/role-management`}>Role Management</Link>,
        permission: [permissions.GeneralSettings, permissions.GRMTAdmin],
        moreThenOne: true
      },
      {
        id: `/${path}/settings/notification-settings`,
        title: <Link to={`/${path}/settings/notification-settings`}>Notification Settings</Link>,
        permission: [permissions.GeneralSettings, permissions.GeneralAlertMonitor],
        moreThenOne: true
      }
    ]
  },
  {
    id: `/${path}/reports`,
    title: 'Reports',
    icon: 'bc-icon-reports',
    permission: permissions.GRMTReports,
    data: [
      {
        id: `/${path}/reports/alert-settings-report`,
        title: <Link to={`/${path}/reports/alert-settings-report`}>Alert Settings Report</Link>,
        permission: permissions.GRMTReports
      }
    ]
  }
];
